// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__Xo-pQ","switchGroup":"styles_switchGroup__p6uwr"};